/**
 * 系统更新公告服务模块
 */

import { apiService } from './api'
import type {
  SystemUpdate,
  SystemUpdateApiResponse,
  SystemUpdateListData,
  SystemUpdateListParams,
} from '@/types/systemUpdate'

const SYSTEM_UPDATE_ENDPOINT = '/api/system-updates' as const

/**
 * 获取公开系统更新公告列表
 * @param params 查询参数
 * @returns 系统更新公告列表数据
 */
export async function getSystemUpdateList(
  params?: SystemUpdateListParams
): Promise<SystemUpdateListData> {
  const queryParams: Record<string, string> = {}

  if (params?.current !== undefined) {
    queryParams['current'] = String(params.current)
  }
  if (params?.pageSize !== undefined) {
    queryParams['pageSize'] = String(params.pageSize)
  }

  const response = await apiService.get<SystemUpdateApiResponse<SystemUpdateListData>>(
    SYSTEM_UPDATE_ENDPOINT,
    queryParams
  )
  return response.data
}

/**
 * 获取系统更新公告详情
 * @param id 公告 ID
 * @returns 公告详情
 */
export async function getSystemUpdateDetail(id: string): Promise<SystemUpdate> {
  const response = await apiService.get<SystemUpdateApiResponse<SystemUpdate>>(
    `${SYSTEM_UPDATE_ENDPOINT}/${id}`
  )
  return response.data
}

/**
 * 获取最新公开系统更新公告
 * @returns 最新公告或 null
 */
export async function getLatestSystemUpdate(): Promise<SystemUpdate | null> {
  const response = await apiService.get<SystemUpdateApiResponse<SystemUpdate | null>>(
    `${SYSTEM_UPDATE_ENDPOINT}/latest`
  )
  return response.data
}
